
import { TRule } from "@nationbetter/nb-components/src/models/Element";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    HorizontalStepperLabel: () => import("../elements/HorizontalStepperLabel.vue"),
    HorizontalStepperLabelStep: () => import("../elements/HorizontalStepperLabelStep.vue"),
  },
})
export default class StepFourSMS extends Vue {
  @Prop({ type: String }) readonly errorMessage!: string;
  @Prop({ type: Boolean }) readonly loading!: boolean;

  files: File[] = [];
  signedAndDated = null;
  dialogUpload = false;

  options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  rules: TRule<number>[] = [(v) => !!v || v === null || "Error is here"];

  remove(file: File) {
    this.files = this.files.filter((item) => item.name !== file.name);
    this.setFiles();
  }

  get isFormValid() {
    return !!(this.signedAndDated && this.files.length > 0);
  }

  setFiles() {
    this.$emit("setFiles", this.files);
  }

  setStep(step: number) {
    this.$emit("setStep", step);
  }

  success() {
    this.$emit("success");
  }

  closeAlert() {
    this.$emit("closeAlert");
  }
}
